<template>
  <div class="h-full max-w-2xl mx-auto lg:max-w-none lg:w-full">
    <onboarding
      v-model="user"
      :steps="steps"
      :save="save"
      loading-text="Generating report"
      @update="update"
    />
  </div>
</template>

<script setup>
import Onboarding from "@/components/onboardings/Onboarding.vue"
import ReportStepComplete from "@/components/onboardings/ReportStepComplete.vue"
import ReportStepIntro from "@/components/onboardings/ReportStepIntro.vue"
import ReportStepJobPriorities from "@/components/onboardings/ReportStepJobPriorities.vue"
import ReportStepJobSummary from "@/components/onboardings/ReportStepJobSummary.vue"
import ReportStepJobs from "@/components/onboardings/ReportStepJobs.vue"
import ReportStepLsatGpa from "@/components/onboardings/ReportStepLsatGpa.vue"
import ReportStepNational from "@/components/onboardings/ReportStepNational.vue"
import ReportStepRace from "@/components/onboardings/ReportStepRace.vue"
import ReportStepStates from "@/components/onboardings/ReportStepStates.vue"
import { Priority } from "@/models/Priority"
import { api } from "@/api"
import { shallowRef } from "vue"

const user = defineModel({ type: Object, required: true })

const steps = shallowRef([
  ReportStepIntro,
  ReportStepJobs,
  ReportStepNational,
  ReportStepJobPriorities,
  ReportStepJobSummary,
  ReportStepStates,
  ReportStepLsatGpa,
  ReportStepRace,
  ReportStepComplete,
])

const update = (e) => {
  const { name, value } = e

  user.value = {
    ...user.value,
    [name]: value,
  }
}

const save = () => {
  const payload = {
    national: user.value.report.national,
    gpa: user.value.gpa,
    lsat: user.value.lsat,
    race: user.value.race,
    priorityLaw: user.value.report.priority_law ?? Priority.NO,
    priorityFirm: user.value.report.priority_firm ?? Priority.NO,
    priorityBiglaw: user.value.report.priority_biglaw ?? Priority.NO,
    priorityPublic: user.value.report.priority_public ?? Priority.NO,
    priorityClerk: user.value.report.priority_clerk ?? Priority.NO,
    statesPreferred: user.value.statesPreferred.map(state => state.code),
  }

  return api.reportCreate(payload)
}
</script>
